<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
.w1300 {
  width: 1300px;
  margin: 0 auto;
}
* {
  padding: 0;
  margin: 0;
}
ul li{list-style: none;}
.info p img{width: 74%;margin: 20px 13%;display: block;}
.ql-editor .ql-video{width:74%;margin-left:13%;margin-right:13%;min-height: 560px;}
</style>
